import { api } from '../client';
import type { Device } from '../types';

interface ListParams {
  all?: boolean;
  userId?: number;
  id?: number | number[];
  uniqueId?: string | string[];
}

export const devicesApi = {
  list: (params?: ListParams) => api.get<Device[]>('/devices', { query: params }),
  create: (device: Partial<Device>) => api.post<Device>('/devices', { body: device }),
  update: (id: number, device: Device) => api.put<Device>(`/devices/${id}`, { body: device }),
  delete: (id: number) => api.delete<void>(`/devices/${id}`),
  setAccumulators: (id: number, body: { totalDistance?: number; hours?: number }) =>
    api.put<void>(`/devices/${id}/accumulators`, { body }),
};
